/** localStorage that never throws: private windows and blocked storage fall back to in-memory state. */
export const storage = {
  read<T>(key: string, fallback: T): T {
    try {
      const raw = localStorage.getItem(key)
      return raw ? (JSON.parse(raw) as T) : fallback
    } catch (error) {
      console.warn(`[pos] could not read ${key}`, error)
      return fallback
    }
  },
  write(key: string, value: unknown) {
    try {
      localStorage.setItem(key, JSON.stringify(value))
    } catch (error) {
      console.warn(`[pos] could not save ${key}`, error)
    }
  },
}
